import Vue from 'vue';
import VueMask from 'vue-the-mask';
import VueMoney from 'v-money';
import PortalVue from 'portal-vue';

Vue.use(VueMask);
Vue.use(VueMoney);
Vue.use(PortalVue);
